import { GetNifOrderWithReviewableDocumentsDocument } from '@src/generated/graphql';
import { useCurrentLocale } from '@src/hooks/useCurrentLocale';
import ReviewableDocumentReuploader from '../../documents/components/ReviewableDocumentReuploader';
import { NifOrderStepPageWithReuploadIntakeDocumentProps } from '../types/stepProps';

export function NifOrderReuploadIntakePage({
  nifOrder,
  intakeDocument,
  previousUrl,
  navigateToNextStep,
}: NifOrderStepPageWithReuploadIntakeDocumentProps): JSX.Element {
  const locale = useCurrentLocale();
  return (
    <ReviewableDocumentReuploader
      reviewableDocument={intakeDocument.reviewableDocument}
      previousUrl={previousUrl}
      navigateToNextStep={navigateToNextStep}
      title={intakeDocument.titleTranslated}
      disableCategorySelectionForCategories={[
        'nif_proof_of_identity',
        'nif_parent_proof_of_identity',
      ]}
      refetchQueries={[
        {
          query: GetNifOrderWithReviewableDocumentsDocument,
          variables: { id: nifOrder.id, locale },
        },
      ]}
    />
  );
}
